module.exports = __webpack_public_path__ + "img/铁路明细表示例.40df0894.png";